<template>
    <div class="AAA">
		<!-- <div @click="handleJoinRoom()">
			进入
		</div> -->
        <!-- 主视频窗口 -->
        <div class="onLineMeeting flex fsb">
			<div class="member-list">
				<div v-for="item in memberList" :key="item">
					<div>{{item}}</div>
				</div>
			</div>
			<div style="width:58%;height:100%;margin-right:2%">
				<div v-if="localStream">
					<div id="localStream" class="local-stream" style="width:100%;height:100%;"></div>
					<div class="local-stream-control">
						<div class="video-control control">
							<span v-if="!isMutedVideo" @click="muteVideo">
							关闭video
							</span>
							<span v-if="isMutedVideo"  @click="unmuteVideo">
							打开video
							</span>
						</div>
						<div class="audio-control control">
							<span v-if="!isMutedAudio" @click="muteAudio">
							关闭麦克风
							</span>
							<span v-if="isMutedAudio" @click="unmuteAudio">
							打开麦克风
							</span>
						</div>
					</div>
				</div>
			</div>
			<div class="play-stream">
				<div
					v-for="(item) in remoteStreamList"
					:key="item.getUserId()"
					:id="item.getUserId()"
					class="remote-stream-container">
					<div style="color:#ffffff">
						{{item.getUserId()}}
					</div>
				</div>
				
			</div>
            
        </div>
		<div class="bottom_div">
			<div @click="stopMeeting()">结束会议</div>
			<div @click="handleLeave()">退出会议</div>
		</div>
        
    </div>
</template>

<script>

// import TRTC from 'trtc-js-sdk'
import * as LibGenerateTestUserSig from '@/utils/lib-generate-test-usersig.min.js'
// import { deepClone } from '@/utils/function'
import rtc from '@/mixins/rtc.js';
import shareRtc from  '@/mixins/share-rtc.js';

import { 
  stopRoom,
} from '@/api/index'

export default {
	mixins: [rtc, shareRtc],
	props: {
		type: String,
		cameraId: String,
		microphoneId: String,
		inviteUserSig: String,
		userName: String,
	},
    data() {
        return {
            isMutedVideo: false,
            isMutedAudio: false,
            userId: '', //用户id --可更改
            roomId: '', //房间号--加入相同房间才能聊
            sdkAppId: 1400776723, //sdkID
            secretKey: '68890e677c4c3dcf3592a5fb1b9fb7f78131c7709a64fb5d6ac97894697fb8ee',
            userSig: '', //签名
            EXPIRETIME: 604800,
			userList: [],
			memberList: [],
			isHave: false,

        }
	},
	computed: {
		isHostMode() {
			return this.type !== 'invite';
		},
		isEnLang() {
			return this.$i18n.locale === 'en';
		},
		showInviteLink() {
			return this.isHostMode && (this.isJoined || this.isShareJoined) && this.inviteLink;
		},
	},
	watch: {
		cameraId(val) {
			this.switchDevice('video', val);
		},
		microphoneId(val) {
			this.switchDevice('audio', val);
		},
	},
    async mounted(){
        if (this.$route.params.id) {
			if (this.$route.params.id != 999) {
				this.roomId = this.$route.params.id * 1
				// console.log('this.$route--->', this.$route)
				this.userId = `user_${parseInt(Math.random() * 100000000, 10)}`
				// const generator = new LibGenerateTestUserSig(this.sdkAppId, this.secretKey,604800);
				// this.userSig = generator.genTestUserSig(this.userId);
				
				// await this.initClient();
				// await this.join();
				// await this.initLocalStream();
				// await this.playLocalStream();
				// await this.publish();
				await this.handleJoinRoom();
			} else {
				this.$alert('会议已结束', '提示', {
					confirmButtonText: '确定',
					closeOnClickModal: true,
					type: 'error',
					callback: () => {
						this.$router.push('/onLineMeeting')
					}
				});
			}
            
        } else {
            window.close()
        }

        
    },
    methods: {
		stopMeeting() {
			let params = {
				Action:'DismissRoom',
				SdkAppId: this.sdkAppId,
				RoomId: this.roomId
			}
			stopRoom(params).then(res => {
				console.log(res)
			}).finally(() => {
			})
		},
		generateInviteLink() {
			if (!this.isHostMode) {
				return;
			}
			const { sdkAppId, secretKey, roomId } = this;
			const inviteUserId = `user_${parseInt(Math.random() * 100000000, 10)}`;
			const userSigGenerator = new LibGenerateTestUserSig(sdkAppId, secretKey, 604800);
			const inviteUserSig = userSigGenerator.genTestUserSig(inviteUserId);
			this.inviteLink = encodeURI(`${location.origin}${location.pathname}#/invite?sdkAppId=${sdkAppId}&userSig=${inviteUserSig}&roomId=${roomId}&userId=${inviteUserId}`);
		},
		// 点击【Join Room】按钮
		async handleJoinRoom() {
			if (this.isHostMode) {
				if (!this.sdkAppId || !this.secretKey) {
				alert(this.$t('Please enter sdkAppId and secretKey'));
				return;
				}
				if (!this.userId || !this.roomId) {
				alert(this.$t('Please enter userId and roomId'));
				return;
				}
				const userSigGenerator = new LibGenerateTestUserSig(this.sdkAppId, this.secretKey, 604800);
				this.userSig = userSigGenerator.genTestUserSig(this.userId);
			} else {
				if (!this.sdkAppId || !this.inviteUserSig || !this.userId || !this.roomId) {
				alert(this.$t('Please reacquire the invitation link'));
				return;
				}
				this.userSig = this.inviteUserSig;
			}
			await this.initClient();
			await this.join();
			await this.initLocalStream();
			await this.playLocalStream();
			await this.publish();
			this.generateInviteLink();
		},

		// 点击【Publish】按钮
		async handlePublish() {
			await this.publish();
		},

		// 点击【Unpublish】按钮
		async handleUnpublish() {
			await this.unPublish();
		},

		// 点击【Leave Room】按钮
		async handleLeave() {
			await this.leave();
		},

		// 点击【开始屏幕分享】按钮
		async handleStartScreenShare() {
			if (!this.sdkAppId || !this.secretKey) {
				alert(this.$t('Please enter sdkAppId and secretKey'));
				return;
			}
			await this.initShareClient();
			await this.initShareLocalStream();
			await this.handleShareJoin();
			await this.handleSharePublish();
			this.generateInviteLink();
		},

		// 点击【停止屏幕分享按钮】
		async handleStopScreenShare() {
			await this.handleShareUnpublish();
			await this.handleShareLeave();
		},

		// 显示成功的 Log
		addSuccessLog(log) {
			console.log(log)
			// if (!this.isHostMode) {
			//   return;
			// }
			// this.logList.push({
			//   type: 'success',
			//   log,
			// });
			// const { scrollHeight } = this.$refs.logContainer;
			// this.$refs.logContainer.scrollTop = scrollHeight;
		},

		// 显示失败的 Log
		addFailedLog(log) {
			console.log(log)
			// if (!this.isHostMode) {
			//   return;
			// }
			// this.logList.push({
			//   type: 'failed',
			//   log,
			// });
			// const { scrollHeight } = this.$refs.logContainer;
			// this.$refs.logContainer.scrollTop = scrollHeight;
		},
		// reportSuccessEvent(name) {
		// 	this.$aegis.reportEvent({
		// 		name,
		// 		ext1: `${name}-success`,
		// 		ext2: 'webrtcQuickDemoVue2',
		// 		ext3: this.sdkAppId,
		// 	});
		// },
		// reportFailedEvent(name, error, type = 'rtc') {
		// 	this.$aegis.reportEvent({
		// 		name,
		// 		ext1: `${name}-failed#${this.roomId}*${type === 'share' ? this.shareUserId : this.userId}*${error.message}`,
		// 		ext2: 'webrtcQuickDemoVue2',
		// 		ext3: this.sdkAppId,
		// 	});
		// },
	},
}
</script>

<style lang="scss" scoped>
.onLineMeeting{
    background: #000000;
    position: absolute;
    width:100%;
	overflow: hidden;
    height: calc(100% - 118px - 60px)
}
.play-stream{
    width:20%;
    height: 100%;
    overflow-y: auto;
}
.member-list{
	widows: 20%;
	height: 100%;
	overflow-y: auto;
}
.local-stream{
	border: 1px solid red;
	background: #ffffff;
}
.local-stream-control {
	width: 78%;
	height: 30px;
	position: absolute;
	bottom: 0;
	background-color: rgba(0, 0, 0, 0.3);
	display: flex;
	justify-content: flex-start;
	align-items: center;
	padding: 0 10px;
	color: #ffffff;
	.video-control{
		margin-right: 10px;
	}
}
.bottom_div{
	position: absolute;
	bottom: 0;
}
</style>